import script from "./saleDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./saleDetail.vue?vue&type=script&setup=true&lang=js"

import "./saleDetail.vue?vue&type=style&index=0&id=05d26d70&lang=less"

const __exports__ = script;

export default __exports__